<template>
    <app-layout v-if="isPageReady" printClass="print-referral-listing">
        <common-tabs class="referral-listing-wrapper" :tabs="tabOptions" :activeTab="activeTab" @tab-click="changeTab($event)">
            <template v-if="!$auth.isUserTemporaryPhysician()" v-slot:referrals>
                <referral v-if="activeTab === 'referrals'"></referral>
            </template>
            <template v-else v-slot:referrals>
                <temporary-referral v-if="activeTab === 'referrals'"></temporary-referral>
            </template>
            <template v-slot:pool>
                <referral-pool v-if="activeTab === 'pool'"></referral-pool>
            </template>
            <template v-slot:referrals-patient>
                <referral v-if="activeTab === 'referrals-patient'" :isFromPatient="true"></referral>
            </template>
            <template v-slot:pool-patient>
                <referral-pool v-if="activeTab === 'pool-patient'" :isFromPatient="true"></referral-pool>
            </template>
        </common-tabs>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import ReferralPool from '../pool/ReferralPool.vue'
    import Referral from '../referral/Referral.vue'
    import TemporaryReferral from '../temporary-referrals/TemporaryReferral.vue'
    import Store from '~/store'
    import ReferralService from 'services/ReferralService'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],

        components: {
            AppLayout,
            ReferralPool,
            Referral,
            TemporaryReferral,
        },

        data() {
            return {
                activeTab: undefined,
                referralsByStatuses: {},
            }
        },

        provide() {
            return {
                isReferralPool: false,
            }
        },

        computed: {
            tabOptions() {
                const tabs = [
                    {
                        displayName: this.$t('layouts.app.topnav.provider_direct'),
                        name: 'referrals',
                        icon: 'direct-referral',
                        badge: this.$route.params.type === 'received' ? this.getReceivedDirectReferralFromProviderCount() : null,
                    },
                ]

                tabs.push({
                    displayName: this.$t('layouts.app.topnav.provider_match'),
                    name: 'pool',
                    icon: 'match-referral',
                    badge:
                        this.$route.params.type === 'received'
                            ? this.referralsByStatuses?.received.find((r) => r.referralStatus === 'REFERRALS_POOL_RECEIVED')
                                  ?.count
                            : this.referralsByStatuses?.received.find((r) => r.referralStatus === 'REFERRALS_POOL_SLOTS_PROPOSED')
                                  ?.count,
                })

                if (
                    this.$route.params.type === 'received' &&
                    (this.$auth.isActiveMemberPhysician() || this.$auth.isPracticeAncillary())
                ) {
                    tabs.push(
                        {
                            displayName: this.$t('layouts.app.topnav.patient_direct'),
                            name: 'referrals-patient',
                            icon: 'match-referral',
                            badge: this.referralsByStatuses?.received.find((r) => r.referralStatus === 'CREATED_BY_PATIENT')
                                ?.count,
                        },
                        {
                            displayName: this.$t('layouts.app.topnav.patient_match'),
                            name: 'pool-patient',
                            icon: 'match-referral',
                            badge: this.referralsByStatuses?.received.find(
                                (r) => r.referralStatus === 'REFERRALS_POOL_RECEIVED_BY_PATIENT',
                            )?.count,
                        },
                    )
                }
                return tabs
            },
        },

        methods: {
            changeTab(event) {
                this.$router.push({ name: `referrals.${this.$route.params.type}.${event}` })
                this.activeTab = event
            },

            getReceivedDirectReferralFromProviderCount() {
                return this.referralsByStatuses?.received
                    .filter((r) => r.referralStatus === 'PATIENT_VISIT_PAST' || r.referralStatus === 'CREATED')
                    .reduce((acc, curr) => {
                        acc += curr.count
                        return acc
                    }, 0)
            },

            fetchReceivedReferralsCountByStatus() {
                const params = {}
                if (this.$auth.isPracticeAncillary()) {
                    params.toPracticeId = this.$auth.getPractice().id
                } else {
                    params.toUserId = this.$auth.getUser().id
                }

                ReferralService.fetchReferralsCountByStatus(params, 'received')
            },

            fetchMadeReferralsCountByStatus() {
                const params = {}
                if (this.$auth.isPracticeAncillary()) {
                    params.fromPracticeId = this.$auth.getPractice().id
                } else {
                    params.fromUserId = this.$auth.getUser().id
                }

                ReferralService.fetchReferralsCountByStatus(params, 'made')
            },
        },

        watch: {
            '$route.params.type'() {
                this.changeTab(this.$route.params.tabType)
            },
        },

        mounted() {
            if (
                !this.$auth.isUserPracticeDemo() &&
                !this.$auth.isUserTemporaryPhysician() &&
                (!Store.getters['auth/getPendingReferralAction'].received.length ||
                    !Store.getters['auth/getPendingReferralAction'].made.length)
            ) {
                this.fetchReceivedReferralsCountByStatus()
                this.fetchMadeReferralsCountByStatus()
            }

            this.referralsByStatuses = Store.getters['auth/getPendingReferralAction']

            if (this.$route.params.tabType) {
                this.changeTab(this.$route.params.tabType)
            }
        },
    }
</script>
<style lang="scss">
    .referral-listing-wrapper {
        .tabcontent {
            margin-top: 30px;
        }
    }
</style>
